<template>
    <!-- 单选题 -->
    <div class="question-item">
        <div class="question-item-num">
            <question-title v-if="titleIsEdit" :dataList="dataList" @numberBlur="(e) => emits('numberChange', e)" />
            <div v-else style="margin-top: 8px">{{ dataList.questionNumber }}</div>
        </div>
        <div class="question-item-content">
            <div class="title">
                <rich-text-editor ref="titileInput" class="titile-input" v-model:valueData="dataList.title" />
            </div>
            <div class="content">
                <div class="upload-box">
                    <img src="@/images/icon/upload@3x.png" />
                    <div class="text">上传文件/图片</div>
                </div>
                <div class="file-limit">
                    <span>{{ dataList.fileFormat ? `支持格式：${fileFormat[dataList.fileFormat]}` : "不限制格式" }}</span
                    ><span>,最多{{ dataList.fileNumber }}个,单个文件大小不超过{{ dataList.fileSize }}M</span>
                </div>
            </div>
            <!-- 底部操作栏 -->
            <div class="footer-operation" v-if="footerShow">
                <action-bar
                    class="action-bar"
                    @addCopy="() => emits('copyQuestion', dataList)"
                    @deleteQuestion="() => emits('deleteQuestion')"
                    @view="(e) => emits('singlePreview', e)"
                ></action-bar>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-file-upload">
// js
import { ref, watch, provide } from "vue";
// components
import RichTextEditor from "@/components/editor/RichTextEditor.vue";
import ActionBar from "@/components/action/ActionBar.vue";
import QuestionTitle from "@/components/question/QuestionNumber.vue";

// props
const props = defineProps({
    // 是否展示底部操作栏
    footerShow: {
        type: Boolean,
        default: true,
    },
    // 题号是否可编辑
    titleIsEdit: {
        type: Boolean,
        default: true,
    },
    // 数据渲染
    dataList: {
        type: Object,
        default: () => ({}),
    },
});
// 复制题目，删除题目, 数据改变, 单题预览;
const emits = defineEmits(["copyQuestion", "deleteQuestion", "change", "singlePreview", "numberChange"]);
const titileInput = ref(null);
const fileFormat = {
    P: "png, jpg, gift, bmp",
    V: "mp4, flv, webm, mov, m4v, wmv, avi",
    A: "mp3, wma, wav, amr, m4a, aac",
};

watch(
    () => props.dataList,
    (curr, old) => {
        emits("change", curr);
    },
    { deep: true }
);

provide("data", props.dataList);
defineExpose({ titileInput });
</script>
<style lang="scss" scoped>
@use "@/css/common.scss" as *;

.upload-box {
    width: 108px;
    height: 108px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border-radius: 4px;
    border: 1px solid rgba(229, 232, 238, 1);
    img {
        width: 32px;
        height: 32px;
        margin: 0 auto;
        margin-bottom: 11px;
    }
    .text {
        font-size: 12px;
        font-weight: 400;
        color: rgba(112, 120, 134, 1);
        text-align: center;
    }
}
.file-limit {
    font-size: 12px;
    font-weight: 400;
    color: rgba(183, 186, 191, 1);
    margin-top: 12px;
}
</style>
